import React from 'react';
import { Col, Row } from 'antd';
import StripeWrapper from './StripeWrapper';

import planImage from '../../assets/images/bitmap3919D27C.png';
import logo from '../../assets/images/logo-dark.svg';

import './Payment.css';

function PaymentForm() {
  return (
    <div className="AppWrapper">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      {/*<h1 className="h1 mb-4">Subscriptions</h1>*/}
      <div className="AppContentWrapper">
        <Row>
          <Col span={14} className="gutter-row border-right">
            <h2 className="h2">Payment</h2>
            <div className="gutter-box">
              <StripeWrapper />
            </div>
          </Col>
          <Col span={10} className="gutter-row">
            <h2 className="h2">Order Summary</h2>
            <div className="gutter-box text-center">
              <img src={planImage} width="161" height="275" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PaymentForm;




// WEBPACK FOOTER //
// ./src/containers/Payment/index.js